<template>
  <div>
    <div gt_ParamOrbitTransfert2-v-step="1"></div>
    <div gt_ParamOrbitTransfert2-v-step="2"></div>
    <exo-table :root="_self" enableShareAndArchive overviewAction> </exo-table>
    <v-col ref="missionTableErrorDisplay"> </v-col>
    <v-tour
      name="paramOrbitalTransfer2TourMissions"
      :steps="steps_missions"
      :callbacks="customCallbackMission"
      :options="noSkipStepOption"
    ></v-tour>
  </div>
</template>

<script>
import errorMixin from '../mixins/logHandler.js'
import fieldsDescription from '../tools/fieldsDescription.json'
import dataTools from '../tools/data.js'
import missionTools from '../store/mission.js'
import Vue from 'vue'
import { noSkipStepOption } from '../components/GuidedTutorials/guidedTutorialConstraints.js'
import guidedTutorialParamOrbitalTransfer2, {
  steps_missions
} from '../components/GuidedTutorials/guidedTutorialParamOrbitalTransfer2.js'
import { mapGetters, mapActions } from 'vuex'

export default {
  name: 'mission',

  mixins: [errorMixin],

  async mounted() {
    this.refreshTable()
    this.resetCurrentMission()
    await this.loadMissions(this.$root)
    this.$root.$on('mission-list-updated', this.missionListUpdatedHandler)
    this.setCurrentMission(null)
    if (this.gt_OrbitTransferParam2.isActive) {
      this.$tours['paramOrbitalTransfer2TourMissions'].start()
    }
  },

  beforeDestroy() {
    this.$root.$off('mission-list-updated', this.missionListUpdatedHandler)
  },

  computed: {
    ...mapGetters({
      currentUser: 'currentUser',
      missions: 'missions',
      gt_OrbitTransferParam2: 'gt_OrbitTransferParam2'
    })
  },

  watch: {
    'gt_OrbitTransferParam2.isActive'(val) {
      if (this.gt_OrbitTransferParam2.isActive) {
        this.$tours['paramOrbitalTransfer2TourMissions'].start()
      }
    }
  },

  data() {
    return {
      tableFields: [
        { value: 'displayedName', text: 'Name', sortable: true },
        { value: 'typeName', text: 'Module', sortable: true },
        { value: 'type', text: 'Type', sortable: true },
        { value: 'description', text: 'Description', sortable: true },
        { value: 'updatedAt', text: 'Last update', sortable: true },
        { value: 'actions', text: 'Actions', sortable: false }
      ],
      editMissionIsClicked: false,
      steps_missions: steps_missions,
      noSkipStepOption: noSkipStepOption,
      customCallbackMission: {
        onSkip: () => {
          if (this.gt_OrbitTransferParam2.isActive) {
            guidedTutorialParamOrbitalTransfer2.stopAllTours(this)
          }
        },
        onFinish: () => {
          if (
            this.gt_OrbitTransferParam2.isActive &&
            !this.editMissionIsClicked
          ) {
            this.$tours['paramOrbitalTransfer2TourMissions'].start(1)
          }
        }
      },
      tableItems: this.missions,

      inputs: {
        displayForm: false
      },

      missionTypeAddresses: [
        'parametricstudyrequests',
        'simulationrequests',
        'deploymentrequests',
        'constellationperformanceanalysisrequests',
        'constellationgenerationrequests',
        'constellationsimulationrequests',
        'constellationoptimizationrequests',
        'maneuveranalysisrequests',
        'maneuverrestitutionrequests',
        'maneuvercatalogueanalysisrequests',
        'datageneratorrequests',
        'evasivemaneuverrequests',
        'screeningcatalogueanalysisrequests',
        'opticaldatagenerationrequests',
        'tlescreeningrequests',
        'earthmoontrajectoryrequests',
        'formationflyingsimulationrequests',
        'inspectionsimulationrequests'
      ]
    }
  },

  methods: {
    ...mapActions([
      'loadMissions',
      'setCurrentMission',
      'start_gt_OrbitTransferParam2'
    ]),

    missionListUpdatedHandler() {
      this.refreshTable()
    },

    // TODO MFI too much code copied
    overview(mission) {
      this.sendMissionEventAfterRedirectionToDashboard(
        'set-current-mission',
        mission
      )
    },

    sendMissionEventAfterRedirectionToDashboard(eventName, mission) {
      if (this.gt_OrbitTransferParam2.isActive) {
        this.$tours['paramOrbitalTransfer2TourMissions'].start(1)
      } else {
        this.resetCurrentMission()
        this.redirectToMissionDashboard(mission.typeName)
        // event send to root because it should be treated by sub components
        // use nextTick to be sure mission components are created and can handle events
        Vue.nextTick(() => {
          this.$root.$emit(eventName, mission)
        })
      }
    },

    redirectToMissionDashboard(typeName) {
      this.$router.push({
        path: '/' + missionTools.missionUrlMapping[typeName].dashboard
      })
    },

    async refreshTable() {
      this.tableItems = this.missions
      return this.tableItems.sort((a, b) => {
        return a.typeName < b.typeName ? -1 : 1
      })
    },

    getInfos(item) {
      return dataTools.getInfos(item)
    },

    redirectToNewMissionPage() {
      this.inputs.displayForm = false
      this.$router.push({ path: '/createmission' })
    },

    sendMissionEventAfterRedirectionToSettings(eventName, mission) {
      if (this.gt_OrbitTransferParam2.isActive) {
        guidedTutorialParamOrbitalTransfer2.handleRedirectOnTutorialParamOrbitalTransfer2(
          this,
          mission,
          eventName
        )
      } else if (mission.type === 'Simulator') {
        this.redirectToSimulatorMissionSettings()
        Vue.nextTick(() => {
          this.$root.$emit(eventName, mission)
        })
      } else {
        this.redirectToMissionSetting(mission.typeName)
        // event send to root because it should be treated by sub components
        // use nextTick to be sure mission components are created and can handle events
        Vue.nextTick(() => {
          this.$root.$emit(eventName, mission)
        })
      }
    },

    resetCurrentMission() {
      // immediate effect
      this.$root.$emit('set-current-mission', null)
    },

    editMission(mission) {
      this.sendMissionEventAfterRedirectionToSettings(
        'set-current-mission',
        mission
      )
    },

    copyMission(mission) {
      this.sendMissionEventAfterRedirectionToSettings('copy-mission', mission)
    },

    redirectToMissionSetting(typeName) {
      this.$router.push({
        path: '/' + missionTools.missionUrlMapping[typeName].settings
      })
    },

    redirectToSimulatorMissionSettings() {
      this.$router.push({
        path: '/numericalsimulatormission'
      })
    },

    // Methods to manage result popup
    info(mission, button) {
      this.$router.push({
        name: mission.typeName + 'Dashboard',
        params: { mission }
      })
      // TODO change props parameter to a more proper way
      // TODO MFI do like edit mission
    },

    getCurrentFormAPI(item) {
      return item.typeName + 's'
    },

    getItemAPI(item) {
      return this.getAPI(this.getCurrentFormAPI(item))
    },

    // TODO this method is copied from forms, it should be but in tool file like data.js. Also copied in application layour
    getAPI(objectAPI) {
      return '/users/' + this.currentUser.id + '/' + objectAPI.toLowerCase()
    },

    getCurrentFormTitle() {
      return 'Mission'
    },

    getStringFields() {
      return ['displayedName', 'description']
    },

    getValueFields() {
      return []
    },

    getReferenceFields() {
      return []
    },

    getBooleanFields() {
      return []
    },

    getCustomFields() {
      return []
    },

    getDateFields() {
      return ['updatedAt']
    },

    // TODO MFI click on table line =>  redirect to overview
    removeIfNotUsedAsReference: function (item, index, button) {
      let self = this
      let objectName = item.name
      let objectId = item.id
      this.$http
        .delete(this.getItemAPI(item) + '/' + item.id)
        .then(() => {
          self.successAlertDisplayed = true
          self.successAlertMessage = objectName + ' deleted'
          self.$root.$emit('delete-mission', objectId)
        })
        .catch((e) => {
          self.displayMessage(
            'Error deleting ' + objectName + '. ',
            e,
            'notification',
            'error'
          )
          self.refreshTable()
        })
    },

    copy(item) {
      this.copyMission(item)
    },

    edit(item, index) {
      this.editMission(item)
    },

    removeAll: function () {
      const typesInUserMissions = []

      for (const mission of this.tableItems) {
        const apiAddress = mission.typeName + 's'
        if (typesInUserMissions.indexOf(apiAddress) === -1) {
          typesInUserMissions.push(apiAddress)
        }
      }

      let self = this
      for (const address of typesInUserMissions) {
        this.$http
          .delete(this.getAPI(address))
          .then((response) => {
            this.resetCurrentMission()
            self.$root.$emit('update-mission-list')
          })
          .catch((e) => {
            self.displayMessage(
              'Error deleting missions. ',
              e,
              'missionTableErrorDisplay',
              'error'
            )
          })
      }
    },

    getEnumProperties: function () {
      return { typeName: {}, type: {} }
    },

    clearForm() {},

    getCurrentFormType() {
      return null
    },

    displayEnumValue(exoData, field) {
      try {
        if (field === 'typeName') {
          if (
            exoData.typeName === 'ConstellationPerformanceAnalysisRequest' ||
            exoData.typeName === 'ConstellationOptimizationRequest' ||
            exoData.typeName === 'ConstellationGenerationRequest' ||
            exoData.typeName === 'ConstellationSimulationRequest'
          ) {
            return 'Constellation'
          }
        }
        let desc = fieldsDescription[exoData.typeName]['properties'][field]
        if (desc == null) {
          if (field === 'type') {
            if (
              exoData.typeName === 'ConstellationPerformanceAnalysisRequest'
            ) {
              return 'Performance Analysis'
            } else if (
              exoData.typeName === 'ConstellationOptimizationRequest'
            ) {
              return 'Optimization'
            } else if (exoData.typeName === 'ConstellationGenerationRequest') {
              return 'Generation'
            } else if (exoData.typeName === 'ConstellationSimulationRequest') {
              return 'Simulation'
            } else if (
              exoData.typeName === 'ManeuverRestitutionRequest' ||
              exoData.typeName === 'ManeuverCatalogueAnalysisRequest' ||
              exoData.typeName === 'DataGeneratorRequest' ||
              exoData.typeName === 'ScreeningCatalogueAnalysisRequest'
            ) {
              return 'Defense'
            } else if (exoData.typeName === 'EvasiveManeuverRequest') {
              return 'AsterX'
            }
          }
          console.log(
            'Enum property ' +
              field +
              ' not found in ' +
              exoData.typeName +
              ' description.'
          )
          return 'undefined'
        }
        if (exoData[field] && Array.isArray(exoData[field])) {
          return (
            '[' +
            exoData[field]
              .map((el) => desc['values'].find((val) => val.value === el).text)
              .join(', ') +
            ']'
          )
        } else if (exoData[field]) {
          const enumVal = desc['values'].find(
            (el) => el.value === exoData[field]
          )
          if (enumVal == null) {
            console.log(
              'Enum property ' +
                field +
                ' with value ' +
                exoData[field] +
                ' not found in ' +
                exoData.typeName +
                ' description. Available values : ' +
                desc['values'].join(',')
            )
            return 'undefined'
          }
          return enumVal.text
        }
      } catch (e) {
        console.log(e)
        return 'undefined'
      }
    }
  }
}
</script>
